module.exports = __webpack_public_path__ + "static/img/8.82c3f4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/8.jpg
// module id = yvU2
// module chunks = 1